export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/share/icon-sns-kt-457dde45ca764ae8a8fdf2d2eebbb06a.svg";